import type { TalentDiscoveryAiFilterSearchResponseV2 } from '@revelio/data-access';
import { PositionCategoryKind } from '@revelio/data-access';

import type { AiSearchState } from '../contexts/AiSearchContext';

export const defaultTrialAiSearchState: AiSearchState = {
  prompt: 'Find me data scientists at OpenAI and their top competitors',
  uuid: '9f0ade61-7dc1-4592-a2f6-213339bde0db',
  isCorrect: null,
  response: {
    filters: {
      expr: {
        user_and: {
          children: [
            {
              user_value: {
                child: {
                  val: {
                    pos_attribute: {
                      kind: PositionCategoryKind.RoleK1500,
                      id: 359, // Data Scientist
                      curr: true,
                    },
                  },
                },
              },
            },
            {
              user_value: {
                child: {
                  or: {
                    children: [
                      {
                        val: {
                          pos_attribute: {
                            kind: PositionCategoryKind.CompanyId,
                            id: 576626, // OpenAI
                            curr: true,
                          },
                        },
                      },
                      {
                        val: {
                          pos_attribute: {
                            kind: PositionCategoryKind.CompanyId,
                            id: 744990, // Anthropic
                            curr: true,
                          },
                        },
                      },
                      {
                        val: {
                          pos_attribute: {
                            kind: PositionCategoryKind.CompanyId,
                            id: 233459, // Google
                            curr: true,
                          },
                        },
                      },
                      {
                        val: {
                          pos_attribute: {
                            kind: PositionCategoryKind.CompanyId,
                            id: 350953, // Microsoft
                            curr: true,
                          },
                        },
                      },
                      {
                        val: {
                          pos_attribute: {
                            kind: PositionCategoryKind.CompanyId,
                            id: 434122, // Cohere
                            curr: true,
                          },
                        },
                      },
                    ],
                  },
                },
              },
            },
          ],
        },
      },
      roles_tax: 'custom_role_default',
      skills_tax: 0,
    },
    unknownFilters: [],
    relevantPromptText: {
      valid: ['data scientists', 'at OpenAI', 'top competitors'],
      invalid: [],
    },
  } satisfies TalentDiscoveryAiFilterSearchResponseV2,
};
